import { render, staticRenderFns } from "./lifecycle-event-step.vue?vue&type=template&id=1c9ca210&scoped=true"
import script from "./lifecycle-event-step.vue?vue&type=script&lang=js"
export * from "./lifecycle-event-step.vue?vue&type=script&lang=js"
import style0 from "./lifecycle-event-step.vue?vue&type=style&index=0&id=1c9ca210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ca210",
  null
  
)

export default component.exports